export default "__VITE_ASSET__effe5979__"